<template>
  <TravelersFilterPopup
    :title="title"
    :static-title="headerTitle"
    :is-modal-only="isTabletValue"
    :is-active="isActive"
    filter-key="price"
    :is-disabled-reset-button="isDisabledResetButton"
    :is-scroll="props.isScroll"
    :total-count="categoryStore.experiencesTmpCount"
    :is-loading="categoryStore.isExperiencesCountLoading"
    @open="applyModalStyles"
    @close="onClosePopup"
    @apply="categoryStore.onApplyFilter(EExperienceFilterType.PRICE)"
    @reset="categoryStore.onResetFilter(EExperienceFilterType.PRICE)"
  >
    <FilterPriceContent :is-modal="isTabletValue" />
  </TravelersFilterPopup>
</template>

<script setup lang="ts">
  import { computed } from 'vue';
  import { TravelersFilterPopup } from '@experience/travelers-filter-popup-package';
  import FilterPriceContent from './FilterPriceContent.vue';
  import { useFilterPriceTitle } from '@/features/filter/price/composables/useFilterPriceTitle';
  import { useCategoryStore } from '@/shared/store';
  import { EExperienceFilterType } from '@/widgets/filtersBlock';
  import { useScreenSize } from '@experience/shared';
  import { applyModalStyles, resetModalStyles } from '@/shared/lib';

  interface Props {
    isScroll?: boolean;
  }

  const { isTablet } = useScreenSize();
  const isTabletValue = computed<boolean>(() => isTablet.value);

  const props = defineProps<Props>();

  const categoryStore = useCategoryStore();

  const { title, headerTitle, isActive } = useFilterPriceTitle();

  const isDisabledResetButton = computed(() => {
    return (
      !categoryStore.tmpFilters[EExperienceFilterType.PRICE].price[0] &&
      !categoryStore.tmpFilters[EExperienceFilterType.PRICE].price[1]
    );
  });

  const onClosePopup = () => {
    resetModalStyles();
    categoryStore.onResetTmpFilter(EExperienceFilterType.PRICE);
  };
</script>

<style lang="scss" scoped>
  :deep(.filter-popup) {
    width: 368px;
    max-width: 100vw;

    .popup__content {
      padding-top: 5px;
    }
  }
</style>
